define('views/shared/tab/tab_panel',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/tab/tab_panel.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
        className: 'tab-panel',
        tagName  : 'div',
        // activityIndicator: true,
        isRender : false,
        template : _.template(Template),
        events   : {},
        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.panel_rendered = false;

            this.panel_content = options.panel_content;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){
            this.$el.attr('data-panel-id', this.panel_content.panel_id);

            this.addPanelContent();
        },

        addPanelContent: function(){
            var that = this;

            if(this.panel_content && this.panel_content.content){

                if(!this.panel_rendered){
                    this.render();
                    this.panel_rendered = true;
                } else {
                    this.$('.js-tab-panel-content').html('');
                }

                // If list is desired for tab panel display and check to ensure content is a list
                if(this.panel_content.list && _.isArray(this.panel_content.content)){

                    // Begin the list and add class name if available
                    var list = document.createElement('ul');

                    if(this.panel_content.list_class){
                        list.className = this.panel_content.list_class;
                    }

                    this.panel_content.content.forEach(function(content){

                        var content_obj = {};

                        // If there is a Class for each piece of content, use the class to display the data
                        if(_.isFunction(that.panel_content.view_class)){

                            var content_view = new that.panel_content.view_class({ data: content });

                            content_obj = content_view.el;

                        } else {
                            content_obj = content.content;
                        }

                        list.appendChild(content_obj);

                    });

                    // Add the HTML to the tab panel content region
                    this.$('.js-tab-panel-content').append(list);

                } else {
                    this.$('.js-tab-panel-content').append(this.panel_content.content);
                }

            }

        },

        reloadPanel: function(content){
            
            if(this.panel_content){

                this.panel_content.content = content;
                this.addPanelContent();

            }

        },

        showPanel: function(){
            
            this.$el.addClass('active');

            if(this.panel_content && this.panel_content.events){

                if(_.isFunction(this.panel_content.events.show)){

                    this.panel_content.events.show();

                }
                
            }

        },

        hidePanel: function(){
            
            this.$el.removeClass('active');

        },

        close: function(){}
    });
});

